module.exports = __webpack_public_path__ + "img/water-sampling.be6a751e.jpg";